import { ActivityEditProps } from "./screens"
import { BatchCreationForm } from "../inputs/BatchCreate"
import ActivityScreenWrapper from "./ActivityScreenWrapper"
import ActivityCreateScreenWrapper from "../creating/ActivityCreateScreenWrapper"
import { useActivityWorkflowActions } from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"

interface ActivityCreateBatchProps extends ActivityEditProps {
  mode?: "create" | "edit"
}

const ActivityCreateBatch = ({ onBack, mode = "edit" }: ActivityCreateBatchProps) => {
  const { setLatestBatch } = useActivityWorkflowActions()

  // Use appropriate wrapper based on mode - create mode doesn't have a current activity
  const Wrapper = mode === "create" ? ActivityCreateScreenWrapper : ActivityScreenWrapper

  return (
    <Wrapper>
      <BatchCreationForm
        onSuccess={(batch) => {
          setLatestBatch(batch)
          onBack()
        }}
      />
    </Wrapper>
  )
}

export default ActivityCreateBatch
